import React from 'react';
import { useTranslation } from 'react-i18next';
import './NoContentForTagsCard.scss';

const NoContentForTagsCard = () => {
  const { t } = useTranslation();
  const noContentMessage = 'couldntFindAnyContent';

  return (
    <div
      className="no-content-for-tags-card content-container"
      data-testid="no-content-for-tags-card"
    >
      <h2>{t(noContentMessage)}</h2>
    </div>
  );
};

export default NoContentForTagsCard;
